import React, { Suspense, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '@@/ui/components/Spinner';
import useCasesUserRole from '../../hooks/useCasesUserRole';
import { getComponentForRole } from '../../common/page-permission-mapping';
import { RoleBasedPageProps } from '../../types/permissions.type';

const RoleBasedPage: React.FC<RoleBasedPageProps> = ({ config }) => {
  const navigate = useNavigate();
  const { role, hasCasesAccess } = useCasesUserRole();

  const Component = getComponentForRole(config, role);

  const defaultLoadingFallback = (
    <div className='flex flex-col items-center justify-center min-h-[400px] space-y-4'>
      <Spinner size='lg' />
      <p className='text-gray-200'>{config.loadingMessage || 'Loading...'}</p>
    </div>
  );

  useEffect(() => {
    if (!hasCasesAccess || !Component) {
      navigate(-1);
    }
  }, [hasCasesAccess, Component, navigate]);

  if (!hasCasesAccess || !Component) {
    return defaultLoadingFallback;
  }

  return (
    <Suspense fallback={defaultLoadingFallback}>
      <Component />
    </Suspense>
  );
};

export default RoleBasedPage;
